import { RECEIVE_PROOF_OF_PERFORMANCE_2PDC_REPORTS } from '@sophocles/entities/ProofOfPerformance2PDCReport/actions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_PROOF_OF_PERFORMANCE_2PDC_REPORTS:
      return state.merge(action.proofOfPerformance2PDCReports);
    default:
      return state;
  }
}

export function proofOfPerformance2PDCReportReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_PROOF_OF_PERFORMANCE_2PDC_REPORTS:
      return getState(state, action);
    default:
      return state;
  }
}
